<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="page container" v-else-if="loaded" >
        
        <div class="row position-relative mt-3" >
            
            <span v-if="editable" class="position-absolute right-0 mt-2 mr-4" >
                <b-button @click="saveIntegration" variant="primary" class="btn btn-sm" > <font-awesome-icon :icon="['far', 'save']" class="mr-1" />  Save </b-button>    
                <b-button @click="edit" v-if="type == 'edit'" variant="outline-secondary" class="btn btn-sm" > <font-awesome-icon :icon="['fa', 'times']" class="mr-1" />  Cancel </b-button>    
            </span>
            
            <b-dropdown v-if="type == 'edit' && !editable " size="sm" html='Actions <svg aria-hidden="true" class="atlass-icon icon-chevron-down fill-white" height="14" width="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.591 5.293a1 1 0 0 1 1.416 1.416l-6.3 6.3a1 1 0 0 1-1.414 0l-6.3-6.3A1 1 0 0 1 2.41 5.293L8 10.884z" fill-rule="evenodd"></path></svg>' variant="primary" right split-variant class="font-size-14 position-absolute right-0 mt-2 mr-4">
                 <b-dropdown-item-button @click="edit"  >Edit</b-dropdown-item-button>
                <b-dropdown-item-button v-if="data.Status" @click="toggleSwitch( 'Status', false )"   >Deactivate</b-dropdown-item-button>
                <b-dropdown-item-button v-else-if="!data.Status" @click="toggleSwitch( 'Status', true )"  >Activate</b-dropdown-item-button>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button variant="danger" @click="preventDelete()" >Delete</b-dropdown-item-button>
            </b-dropdown>
            
            <!-- ADD -->
            <div class="col-12 text-center" v-if="type == 'add' "  >
                
                <div v-if="!integrating"  class="col-12 mt-5 d-none" >
                    <div class="text-center font-weight-bold h1 mt-5" > Connect your Stripe account </div>
                    
                    <div class="text-center font-weight-bold h1 pt-5" >
                        <b-form-input placeholder="Enter your store URL" class="search-input atlass-input-borderless" />
                    </div>
                    
                    <div class="text-center font-weight-bold h1 pt-5" >
                        <button 
                            type="button" 
                            class="btn btn-primary d-inline-block" 
                            @click="saveIntegration()"
                        >
                            Save
                        </button>
                    </div>
                    
                        
                </div>
                
                <div  class="col-12 mt-4" >
                    <p class="text-center font-weight-bold h1 pt-5" > Setting everything up. Might take a while... </p>
                    <spinner type="small" ></spinner>
                </div>
                
            </div>
            <!-- ADD -->
            
            <!-- EDIT -->
            <b-card no-body class="col-12  atlass-tabs" v-if="type == 'edit' " >
                <b-tabs card  >
                    
                    <b-tab @click="goBack" class="p-0" >
                        <template #title>
                            <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back
                        </template>
                    </b-tab>
                    
                    <b-tab title="Overview" class="p-0 " active>
                        <b-card-text>
                            
                            <spinner v-if="!tabloaded" ></spinner>
                            
                            <div v-if="tabloaded"  >
                            <!--  OVERVIEW TAB-->
                                
                                <b-form  @submit.prevent="saveIntegration()" class="atlass-form col-12 mt-3 " >
                                    
                                    <div class="col-12 form-group" >
                                         <b-form-group >
                                            <label> Integration Name: </label>
                                            <span v-if="!editable"  class="font-weight-bold" > {{data.Name}} </span>
                                             <b-input-group v-else-if="editable" >
                                                <b-form-input  
                                                type="text"
                                                v-model="data.Name"
                                                required
                                                placeholder="name">
                                                </b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </div>

                                     <div class="col-12 form-group" >
                                         <b-form-group >
                                            <label> Integration Tag: </label>
                                            <span v-if="!editable" class="font-weight-bold" > !{{data.Tag}} </span>
                                            <b-input-group v-else-if="editable" >
                                                <b-input-group-prepend is-text>  !</b-input-group-prepend>
                                                <b-form-input  id="apiKeyInput"
                                                type="text"
                                                v-model="data.Tag"
                                                required
                                                placeholder="tag">
                                                </b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </div>

                                     <div class="col-12 form-group" >
                                         <b-form-group >
                                            <label> Signing Secret: </label>
                                            <span v-if="!editable" class="font-weight-bold" > {{data.endpointSecret}} </span>
                                            <b-input-group v-else-if="editable" >
                                                <b-form-input  id="endpointSecret"
                                                type="text"
                                                v-model="data.endpointSecret"
                                                required
                                                placeholder="Endpoit Signing Secret">
                                                </b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </div>

                                    <div class="col-12 form-group"  >
                                         <b-form-group >
                                            <label> Status: </label>
                                            <span v-if="!editable" >
                                                <b v-if="data.Status == 1" > Active </b>
                                                <b v-else-if="data.Status == 0"  > Inactive </b>
                                            </span>

                                            <div v-else-if="editable" >
                                                <b-form-checkbox v-model="data.Status" name="check-button" class="cursor-pointer d-inline-block" switch > </b-form-checkbox>
                                                <span v-if="data.Status" > Active </span>
                                                <span v-else-if="!data.Status" > Inactive </span>
                                            </div>

                                        </b-form-group>
                                    </div>

                                </b-form>

                                <div class="col-12" >

                                    <div class="col-12 border-bottom-gray pb-2 mb-4" >
                                        <span class="d-inline-block line-height-31" > <h2 class="h2 font-weight-bold line-height-31" > Actions </h2> </span>
                                    </div>

                                    <div class="col-12 mt-5" >
                                        <div class="row" >
                                            <div class="col-12" >
                                                <h2 class="h3 font-weight-bold line-height-31" > Webhooks </h2>
                                                
                                                <div class="mt-1" v-if="!data.webhook_url" >
                                                    
                                                    Something went wrong when creating the assets. Please try re-integrating again and delete this one. If issue persists, please reach out to us.
                                                    
                                                </div>
                                                
                                                <div class="mt-1 col-12 text-center" v-else-if="data.webhook_url" >
                                                    
                                                    <div class="text-left mt-2 mb-2" > Copy the URL below and follow the instructions <a href="https://theatlass.com/resources/stripe" target="_blank" rel="noreferrer" > here </a> </div>
                                                    
                                                    <pre id="script-tracker" class="prettyprint border-gray mt-2 p-4 border-radius bg-color-graylight grayligher-border"> {{ data.webhook_url }}</pre>

                                                    <button class="btn btn-copy" @click="copyScript( 'tracker' )" > Copy <font-awesome-icon icon="copy"  class="cursor-pointer graymedium-color h4" ></font-awesome-icon> </button>
                                                    
                                                    
                                                    <div class="text-left mt-2 mb-2" > After you've added the webhook, copy the Signing secret and add it above </div>
                                                    
                                                </div>

                                            </div>
                                            
                                        </div>
                                    </div>

                                </div>

                            <!--  OVERVIEW TAB-->
                            </div>
                            
                        </b-card-text>
                    </b-tab>
                    
                </b-tabs>
            </b-card>

            
            <!-- EDIT -->
            
        </div>
        
        
    </div>
</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import helper from '@/helpers/helpers.js';
    
export default {
    name: 'STRIPE',
    components:{
        
    },
    props: {
        ID:{
            type: [String]
        }
    },
    data: function(){
        return {
            loaded: false, 
            data:{
                Name: "Stripe Integration",
                Tag: "stripe",
                Status: true,
                endpointSecret: ''
            },
            type: 'add',
            editable: false,
            tabloaded: false,
            integrating: false
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        
        if( this.ID == 'new' ){
            this.loaded = true
            this.editable = true
            
            setTimeout(function(){ 
                this.integrating = true
            }, 2000 );
            
            setTimeout(function(){ 
                console.log( "save integration" )
                this.saveIntegration()
            }.bind(this), 5000 );
            
        }else{
            this.get_data( this.ID );
        }
        
    },
    methods: {
        
         get_data( ID ){
          
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = this.$firebase.firestore();
            
            var ref = db.collection('organizations/'+orgID+'/integrations').doc( ID )
                                    
            return ref.get()
                .then((snapshot) => {
                    if( !snapshot.empty ){
                        //console.log(snapshot.data())
                        this.data = snapshot.data()
                        this.data.docID = snapshot.id
                        
                        let integration_hash = btoa(orgID+"_"+this.data.docID)
                        this.data.integration_hash = integration_hash
                        this.data.webhook_url = process.env.ROOT_API + "/integrations/stripe/"+ integration_hash // process.env.ROOT_API
                        
                        this.type = 'edit'
                        
                        this.editable = false
                    }else{
                        console.log("No integration set")
                    }
                        
                    this.loaded = true;
                    this.tabloaded = true;
                
                })
          
        },
        
        saveIntegration(){
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            const db = this.$firebase.firestore();
            
            if( this.type == 'add' ){
                this.loaded = false
                let document = {
                    "APPKEY": orgID,
                    "APP": "STRIPE",
                    "Name" : this.data.Name,
                    "Type" : 'checkout',
                    "Tag" : this.data.Tag,
                    "endpointSecret" : this.data.endpointSecret,
                    "Status": this.data.Status
                }
                
                document.datetime = Math.round(+new Date()/1000)
                    
                let ref = db.collection('organizations/'+orgID+'/integrations')
                
                return ref.add( document )
                 .then((result)=>{
                    
                    //SAVE INTEGRATION HASH
                    //let integration_hash = btoa(orgID+"_"+result.id)
                    //document.webhook_url = 
                    //let ref = db.collection('organizations/'+orgID+'/integrations').doc( result.id )
                    //return ref.set( document, { merge: true } )
                    //SAVE INTEGRATION HASH
                    
                    this.get_data(result.id)
                                        
                    this.$toast.success({
                        title:'Success',
                        message: 'Integration successfully created'
                    })
                    
                    this.loaded = true
                    
                })
                
            }else{
                
                let document = this.data
                document.last_update = Math.round(+new Date()/1000)
                                    
                let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.data.docID )
                
                return ref.set( document, { merge: true } )
                .then((result)=>{
                    
                    this.$toast.success({
                        title:'Success',
                        message: 'Changed saved '
                    })
                    
                    this.editable = false
                    
                })
                
            }

            
        },
        
        goBack(){
            this.$router.push({
                name: "Integration",
                params: { APP: 'STRIPE' }
            });
        },
        
        formatData(unix){
            return this.$moment.unix(unix).format( 'MMM D, HH:mm' )
        },
        edit(){
            this.editable = !this.editable
        },
        
        copyScript( type ){
            
            var range = document.createRange();
            range.selectNode(document.getElementById("script-"+type));
            window.getSelection().removeAllRanges(); // clear current selection
            window.getSelection().addRange(range); // to select text
            document.execCommand("copy");
            window.getSelection().removeAllRanges();// to deselect
            
            this.$toast.success({
                title:'Success',
                message:  'Copied to clipboard!'
            })
            
        },
        
        toggleSwitch( field, value ){
            
            let document = {}
            let update = true;
            
            //console.log(this.data)
            
            if( field == 'Status' ){
                this.data.Status = value
                document.Status = value
            }else if( field == 'sync_leads' ){
                let settings = {}
                settings.sync_leads = this.data.settings.sync_leads
                document['settings.sync_leads'] = !this.data.settings.sync_leads
                
                if( !this.data.settings.sync_leads ){
                    update = false
                }else{
                    update = true
                }
                
            }else if( field == 'attribute_campaigns' ){
                document['settings.attribute_campaigns'] = !this.data.settings.attribute_campaigns
            }else if( field == 'audience_ID' ){
                if( this.data.audience_ID == '' ){
                    this.data.settings.sync_leads = false
                }
                document['settings.sync_leads'] = this.data.settings.sync_leads
                document.audience_ID = this.data.audience_ID
            }
            
            document.last_update = Math.round(+new Date()/1000)
            
            if( update ){
                //UPDATE FIRESTORE
                let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
                const db = this.$firebase.firestore();
                let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.data.docID )

                return ref.update( document )
                .then((result)=>{
                    this.$toast.success({
                        title:'Success',
                        message: 'Changed saved '
                    })
                })
            }
            
        },//end toggleSwitch
        
        preventDelete( ){
            
            this.$swal({
                title: 'Are you sure?',
                text: 'This cannot be undone and the conversion will be deleted as well',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) { 
                    
                    this.delete( );
                    
                }
            })
            
        },        
        delete: function( ){
            
            this.loaded = false
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = firebase.firestore();
            
            let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.ID )
            return ref.delete()
            .then(function(){

                 this.$toast.success({
                    title: 'Success',
                    message: 'Integration deleted'
                })

                setTimeout(function(){ 
                    this.loaded = true
                    this.$router.push({
                        name: 'Integrations'
                    }); 
                }.bind(this), this.timeout );

            }.bind(this))
            .catch(function(error){

                //console.error("Error updating document: ", error);
                this.$toast.error({
                    title: 'Error',
                    message: "Something went wrong: "+error
                })

                this.loaded = true

            }.bind(this))
            
        },
        
    },
    watch: {
        ID: function(){
            this.docID = this.ID
            this.get_data();
            
            this.$refs.tags.$el.click()
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
    .tab-pane{
        margin-top: 2rem;
    }
    
</style>



// WEBPACK FOOTER //
// src/templates/setup/integrations/STRIPE.vue